<div tabindex="0" class="link-container" (keydown.enter)="navigate()" (click)="navigate()">
    <a class="link">
        <ng-content></ng-content>
    </a>
</div>
